export default __webpack_public_path__ + "static/media/section0-img2.31834001.png";